<div class="container mx-auto p-8">
  <form [formGroup]="form">
    <h4 class="!text-[24px] text-[#203D54] !font-bold">Scope of Work</h4>

    <!-- Quality Section -->
    <div id="qualityFormContainer" formGroupName="qualityData">
      <div class="bg-blue-100 p-6 rounded-lg shadow-md mb-8">
        <h2 class="!text-[24px] text-[#203D54] !font-semibold mb-4 row">
          Quality
        </h2>
        @for (qualityGroup of qualityGroups.controls; track $index) {
        <div [formGroupName]="$index.toString()" class="sections_borders">
          <div class="mb-2">
            <label
              for="qualityTitle"
              class="block text-[16px] font-medium text-gray-700"
            >
              Title
              <span
                class="text-red-500"
                *ngIf="qualityGroup.get('qualityFile')?.value.length > 0"
                >*</span
              >
            </label>
            <input
              type="text"
              id="qualityTitle"
              formControlName="qualityTitle"
              class="mt-1 p-2 block border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
              placeholder="Enter Title"
            />
          </div>
          <div
            *ngIf="
              qualityGroup.get('qualityTitle')?.touched &&
              qualityGroup.get('qualityTitle')?.invalid
            "
          >
            <span
              *ngIf="qualityGroup.get('qualityTitle')?.errors?.['required']"
              class="text-red-500 text-sm"
              >Title is required</span
            >
          </div>

          <div class="mb-4 mt-4">
            <label
              for="qualityDescription"
              class="block text-[16px] font-medium text-gray-700"
              >Description</label
            >
            <textarea
              id="qualityDescription"
              formControlName="qualityDescription"
              rows="6"
              class="mt-1 p-2 block border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
              placeholder="Enter Description"
            ></textarea>
          </div>

          <label
            for="qualityFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >

          <div class="mb-5 flex">
            <!-- Hidden input file element -->
            <input
              type="file"
              multiple
              id="qualityFile"
              (change)="onFileUpload($event, 'qualityFile', $index)"
              #fileInput
            />

            <!-- <div
              *ngIf="qualityGroup.get('qualityFile')?.value.length > 0"
              class="flex mt-5 w-[103px] !h-[153px] ml-2"
              >
              <div class="flex-row gap-4 flex-wrap">
                <div
                  *ngFor="let file of qualityGroup.get('qualityFile')?.value"
                >
                  <a [href]="file.url" target="_blank">
                    <img
                      [src]="file.url"
                      [alt]="file.name"
                      class="rounded-lg border"
                    />
                  </a>
                </div>
              </div>
            </div> -->

            <!-- SVG Icon as a button to trigger file input -->
            <!-- <div
              (click)="fileInput.click()"
              class="cursor-pointer mt-5 attachment_icon flex"
             >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
              >
                <path
                  d="M19.2465 0.0151666L19.5 0C20.0307 7.00062e-05 20.5429 0.194905 20.9395 0.54755C21.3361 0.900195 21.5894 1.38612 21.6515 1.91317L21.6667 2.16667V17.3333H36.8333C37.364 17.3334 37.8762 17.5282 38.2728 17.8809C38.6694 18.2335 38.9227 18.7195 38.9848 19.2465L39 19.5C38.9999 20.0307 38.8051 20.5429 38.4524 20.9395C38.0998 21.3361 37.6139 21.5894 37.0868 21.6515L36.8333 21.6667H21.6667V36.8333C21.6666 37.364 21.4718 37.8762 21.1191 38.2728C20.7665 38.6694 20.2805 38.9227 19.7535 38.9848L19.5 39C18.9693 38.9999 18.4571 38.8051 18.0605 38.4524C17.664 38.0998 17.4106 37.6139 17.3485 37.0868L17.3333 36.8333V21.6667H2.16667C1.63598 21.6666 1.12377 21.4718 0.727194 21.1191C0.330618 20.7665 0.0772572 20.2805 0.0151666 19.7535L0 19.5C7.00062e-05 18.9693 0.194905 18.4571 0.54755 18.0605C0.900195 17.664 1.38612 17.4106 1.91317 17.3485L2.16667 17.3333H17.3333V2.16667C17.3334 1.63598 17.5282 1.12377 17.8809 0.727194C18.2335 0.330618 18.7195 0.0772572 19.2465 0.0151666Z"
                  fill="black"
                  fill-opacity="0.7"
                />
              </svg>
            </div> -->
          </div>

          <div
            class="mb-4 "
            *ngIf="qualityGroup.get('qualityFile')?.value.length > 0"
          >
            <label
              for="qualityStatus"
              class="block text-[16px] font-medium text-gray-700"
            >
              Status <span class="text-red-500">*</span>
            </label>
            <select
              id="qualityStatus"
              formControlName="qualityStatus"
              class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
              required
            >
              <option value="" disabled>Select status</option>
              <option value="draft">In Draft</option>
              <option value="pending">Pending</option>
              <option value="accepted">Accepted</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          <div
            *ngIf="
              qualityGroup.get('qualityStatus')?.touched &&
              qualityGroup.get('qualityStatus')?.invalid
            "
          >
            <span
              *ngIf="qualityGroup.get('qualityStatus')?.errors?.['required']"
              class="text-red-500 text-sm"
              >Status is required</span
            >
          </div>
        </div>
        }

        <div class="duplication_icon">
          <button
            type="button"
            (click)="addQualityForm()"
            style="width: 25px; height: 27px; flex-shrink: 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="35"
              viewBox="0 0 33 35"
              fill="none"
            >
              <g filter="url(#filter0_d_3238_12819)">
                <rect x="4" width="25" height="27" fill="#EFF8FF" />
                <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
              </g>
              <path
                d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
                fill="black"
              />
              <defs>
                <filter
                  id="filter0_d_3238_12819"
                  x="0"
                  y="0"
                  width="33"
                  height="35"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3238_12819"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3238_12819"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
        </div>
        <div class="text-right mr-[70px]">
          <button 
          type="button"
          (click) = "onQualitySubmit()" 
          class ="save_button"
          >Save</button>
        </div>

      </div>
    </div>

    <!-- Scope Section -->
    <div class="bg-blue-100 p-6 rounded-lg shadow-md mb-8">
      <h2
        class="!text-[24px] text-[#203D54] !font-semibold mb-4"
        style="font-size: 24px"
      >
        Scope
      </h2>
      <div class="mb-4 sections_borders ">
        <label for="scope" class="block text-[16px] font-medium text-gray-700"
          >Scope <span class="text-red-500 &nbsp">*</span></label
        >
        <textarea
          id="scope"
          formControlName="scope"
          rows="6"
          class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          placeholder="Enter Scope"
        ></textarea>
      </div>
      <div *ngIf="form.get('scope')?.touched && form.get('scope')?.invalid">
        <span
          *ngIf="form.get('scope')?.errors?.['required']"
          class="text-red-500 text-sm"
        >
          Scope is required
        </span>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- Specification Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="specificationData"
    >
      <h2 class="!text-[24px] text-[#203D54] !font-semibold mb-4">
        Specification
      </h2>

      @for (specificationGroup of specificationGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <div class="mb-2">
          <label
            for="specificationTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Title
            <span
              class="text-red-500 &nbsp"
              *ngIf="
                specificationGroup.get('specificationFile')?.value.length > 0
              "
              >*</span
            ></label
          >
          <input
            type="text"
            id="specificationTitle"
            formControlName="specificationTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Title"
          />
        </div>
        <div
          *ngIf="
            specificationGroup.get('specificationTitle')?.touched &&
            specificationGroup.get('specificationTitle')?.invalid
          "
        >
          <span
            *ngIf="specificationGroup.get('specificationTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Title is required</span
          >
        </div>
        <div class="mb-4 mt-4">
          <label
            for="specificationDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >

          <textarea
            id="specificationDescription"
            formControlName="specificationDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>
        <div class="mb-4">
          <label
            for="specificationFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            id="specificationFile"
            multiple
            (change)="onFileUpload($event, 'specificationFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />
          <!-- <div
            *ngIf="
              specificationGroup.get('specificationFile')?.value.length > 0
            "
          >
            <div class="flex gap-4 flex-wrap">
              <div
                *ngFor="
                  let file of specificationGroup.get('specificationFile')?.value
                "
              >
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>

        <div
          class="mb-4"
          *ngIf="specificationGroup.get('specificationFile')?.value.length > 0"
        >
          <label
            for="specificationStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="specificationStatus"
            formControlName="specificationStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div
          *ngIf="
            specificationGroup.get('specificationStatus')?.touched &&
            specificationGroup.get('specificationStatus')?.invalid
          "
        >
          <span
            *ngIf="specificationGroup.get('specificationStatus')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Status is required</span
          >
        </div>
      </div>
      }

      <div class="duplication_icon">
        <button
          type="button"
          (click)="addSpecificationForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>

      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onSpecificationSubmit()" 
        class ="save_button"
        >Save</button>
      </div>

    </div>

    <!-- Standard Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="standardData"
    >
      <h2 class="!text-[24px] text-[#203D54] !font-semibold mb-4">Standard</h2>

      @for (standardGroup of standardGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <!-- Title -->
        <div class="mb-2">
          <label
            for="standardTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Title
            <span
              class="text-red-500"
              *ngIf="standardGroup.get('standardFile')?.value.length > 0"
              >*</span
            ></label
          >
          <input
            type="text"
            id="standardTitle"
            formControlName="standardTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Title"
          />
        </div>

        <!-- Description -->
        <div class="mb-4 mt-4">
          <label
            for="standardDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >
          <textarea
            id="standardDescription"
            formControlName="standardDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>

        <!-- File Upload -->
        <div class="mb-4">
          <label
            for="standardFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            id="standardFile"
            multiple
            (change)="onFileUpload($event, 'standardFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />

          <!-- Image Preview -->
          <!-- <div
            *ngIf="standardGroup.get('standardFile')?.value.length > 0"
            class="mt-5"
            >
            <div class="flex gap-4 flex-wrap">
              <div
                *ngFor="let file of standardGroup.get('standardFile')?.value"
              >
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>

        <!-- Status Select -->
        <div
          class="mb-4"
          *ngIf="standardGroup.get('standardFile')?.value.length > 0"
        >
          <label
            for="standardStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="standardStatus"
            formControlName="standardStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>
      }

      <!-- Add New Form Button -->
      <div class="duplication_icon">
        <button
          type="button"
          (click)="addStandardForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <!-- SVG icon for add button -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onStandardSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- requirement Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="requirementData"
    >
      <h2 class="!text-[24px] text-[#203D54] !font-semibold mb-4">
        Requirement
      </h2>

      @for (requirementGroup of requirementGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <div class="mb-2">
          <label
            for="requirementTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Title
            <span
              class="text-red-500"
              *ngIf="requirementGroup.get('requirementFile')?.value.length > 0"
              >*</span
            ></label
          >
          <input
            type="text"
            id="requirementTitle"
            formControlName="requirementTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Title"
          />
        </div>
        <div
          *ngIf="
            requirementGroup.get('requirementTitle')?.touched &&
            requirementGroup.get('requirementTitle')?.invalid
          "
        >
          <span
            *ngIf="requirementGroup.get('requirementTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Title is required</span
          >
        </div>
        <div class="mb-4 mt-4">
          <label
            for="requirementDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >

          <textarea
            id="requirementDescription"
            formControlName="requirementDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>
        <div class="mb-4">
          <label
            for="requirementFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            id="requirementFile"
            multiple
            (change)="onFileUpload($event, 'requirementFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />
          <!-- <div
            *ngIf="requirementGroup.get('requirementFile')?.value.length > 0"
           >
            <div class="flex gap-4 flex-wrap">
              <div
                *ngFor="
                  let file of requirementGroup.get('requirementFile')?.value
                "
              >
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>
        <div
          class="mb-4"
          *ngIf="requirementGroup.get('requirementFile')?.value.length > 0"
        >
          <label
            for="requirementStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="requirementStatus"
            formControlName="requirementStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div
          *ngIf="
            requirementGroup.get('requirementStatus')?.touched &&
            requirementGroup.get('requirementStatus')?.invalid
          "
        >
          <span
            *ngIf="requirementGroup.get('requirementStatus')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Status is required</span
          >
        </div>
      </div>
      }

      <div class="duplication_icon">
        <button
          type="button"
          (click)="addRequirementForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onRequirementSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- inpsection testing Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="testingData"
    >
      <h2 class="!text-[24px] !font-semibold text-[#203D54] mb-4">
        Inspection / Testing
      </h2>

      @for (testingGroup of testingGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <div class="mb-2">
          <label
            for="testingTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Title
            <span
              class="text-red-500"
              *ngIf="testingGroup.get('testingFile')?.value.length > 0"
              >*</span
            ></label
          >
          <input
            type="text"
            id="testingTitle"
            formControlName="testingTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Title"
          />
        </div>
        <div
          *ngIf="
            testingGroup.get('testingTitle')?.touched &&
            testingGroup.get('testingTitle')?.invalid
          "
        >
          <span
            *ngIf="testingGroup.get('testingTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Title is required</span
          >
        </div>
        <div class="mb-4 mt-4">
          <label
            for="testingDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >

          <textarea
            id="testingDescription"
            formControlName="testingDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>
        <div class="mb-4">
          <label
            for="testingFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            id="testingFile"
            multiple
            (change)="onFileUpload($event, 'testingFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />
          <!-- <div *ngIf="testingGroup.get('testingFile')?.value.length > 0">
            <div class="flex gap-4 flex-wrap">
              <div *ngFor="let file of testingGroup.get('testingFile')?.value">
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>
        <div
          class="mb-4"
          *ngIf="testingGroup.get('testingFile')?.value.length > 0"
        >
          <label
            for="testingStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="testingStatus"
            formControlName="testingStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div
          *ngIf="
            testingGroup.get('testingStatus')?.touched &&
            testingGroup.get('testingStatus')?.invalid
          "
        >
          <span
            *ngIf="testingGroup.get('testingStatus')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Status is required</span
          >
        </div>
      </div>
      }

      <div class="duplication_icon">
        <button
          type="button"
          (click)="addTestingForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onTestingSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- Permit Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="permitData"
    >
      <h2 class="!text-[24px] text-[#203D54] !font-semibold mb-4">Permit</h2>

      @for (permitGroup of permitGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <div class="mb-2">
          <label
            for="permitTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Title
            <span
              class="text-red-500"
              *ngIf="permitGroup.get('permitFile')?.value.length > 0"
              >*</span
            ></label
          >
          <input
            type="text"
            id="permitTitle"
            formControlName="permitTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Title"
          />
        </div>
        <div
          *ngIf="
            permitGroup.get('permitTitle')?.touched &&
            permitGroup.get('permitTitle')?.invalid
          "
        >
          <span
            *ngIf="permitGroup.get('permitTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Title is required</span
          >
        </div>
        <div class="mb-4 mt-4">
          <label
            for="permitDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >

          <textarea
            id="permitDescription"
            formControlName="permitDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>
        <div class="mb-4">
          <label
            for="permitFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            id="permitFile"
            multiple
            (change)="onFileUpload($event, 'permitFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />
          <!-- <div *ngIf="permitGroup.get('permitFile')?.value.length > 0">
            <div class="flex gap-4 flex-wrap">
              <div *ngFor="let file of permitGroup.get('permitFile')?.value">
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>
        <div
          class="mb-4"
          *ngIf="permitGroup.get('permitFile')?.value.length > 0"
        >
          <label
            for="permitStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="permitStatus"
            formControlName="permitStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div
          *ngIf="
            permitGroup.get('permitStatus')?.touched &&
            permitGroup.get('permitStatus')?.invalid
          "
        >
          <span
            *ngIf="permitGroup.get('permitStatus')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Status is required</span
          >
        </div>
      </div>
      }
      <div class="duplication_icon">
        <button
          type="button"
          (click)="addPermitForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onPermitSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- Project Cost Breakdown Section -->
    <div
      class="bg-blue-100 p-6 rounded-lg shadow-md mb-8"
      formGroupName="costBreakDownData"
    >
      <h2 class="!text-[24px] !font-semibold text-[#203D54] mb-4">
        Project Cost Breakdown
      </h2>

      @for (costBreakDownGroup of costBreakDownGroups.controls; track $index) {
      <div [formGroupName]="$index.toString()" class="sections_borders">
        <div class="mb-2">
          <label
            for="costBreakDownTitle"
            class="block text-[16px] font-medium text-gray-700"
            >Cost Type
            <span
              class="text-red-500"
              *ngIf="
                costBreakDownGroup.get('costBreakDownFile')?.value.length > 0
              "
              >*</span
            ></label
          >
          <input
            type="text"
            id="costBreakDownTitle"
            formControlName="costBreakDownTitle"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Cost Type"
          />
        </div>
        <div
          *ngIf="
            costBreakDownGroup.get('costBreakDownTitle')?.touched &&
            costBreakDownGroup.get('costBreakDownTitle')?.invalid
          "
        >
          <span
            *ngIf="costBreakDownGroup.get('costBreakDownTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Title is required</span
          >
        </div>
        <div class="mb-4 mt-4">
          <label
            for="costBreakDownDescription"
            class="block text-[16px] font-medium text-gray-700"
            >Description</label
          >

          <textarea
            id="costBreakDownDescription"
            formControlName="costBreakDownDescription"
            rows="6"
            class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
            placeholder="Enter Description"
          ></textarea>
        </div>
        <div class="mb-4">
          <label
            for="costBreakDownFile"
            class="block text-[16px] font-medium text-gray-700"
            >Attach Documents</label
          >
          <input
            type="file"
            multiple
            id="costBreakDownFile"
            (change)="onFileUpload($event, 'costBreakDownFile', $index)"
            class="mt-1 block w-full text-[16px] text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 focus:outline-none"
          />
          <!-- <div
            *ngIf="
              costBreakDownGroup.get('costBreakDownFile')?.value.length > 0
            "
           >
            <div class="flex gap-4 flex-wrap">
              <div
                *ngFor="
                  let file of costBreakDownGroup.get('costBreakDownFile')?.value
                "
              >
                <a [href]="file.url" target="_blank">
                  <img
                    [src]="file.url"
                    [alt]="file.name"
                    class="w-24 h-24 object-cover rounded-lg border"
                  />
                </a>
              </div>
            </div>
          </div> -->
        </div>
        <div
          class="mb-4"
          *ngIf="costBreakDownGroup.get('costBreakDownFile')?.value.length > 0"
        >
          <label
            for="costBreakDownStatus"
            class="block text-[16px] font-medium text-gray-700"
            >Status<span class="text-red-500">*</span></label
          >
          <select
            id="costBreakDownStatus"
            formControlName="costBreakDownStatus"
            class="mt-1 block w-full h-[35px] border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-[16px]"
          >
            <option value="" disabled selected>Select status</option>
            <option value="draft">In Draft</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div
          *ngIf="
            costBreakDownGroup.get('costBreakDownStatus')?.touched &&
            costBreakDownGroup.get('costBreakDownStatus')?.invalid
          "
        >
          <span
            *ngIf="costBreakDownGroup.get('costBreakDownStatus')?.errors?.['required']"
            class="text-red-500 text-sm"
            >Status is required</span
          >
        </div>
      </div>
      }
      <div class="duplication_icon">
        <button
          type="button"
          (click)="addCostBreakDownForm()"
          style="width: 25px; height: 27px; flex-shrink: 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="35"
            viewBox="0 0 33 35"
            fill="none"
          >
            <g filter="url(#filter0_d_3238_12819)">
              <rect x="4" width="25" height="27" fill="#EFF8FF" />
              <rect x="4.5" y="0.5" width="24" height="26" stroke="#AAD4F5" />
            </g>
            <path
              d="M22 14.875H17.875V19H15.125V14.875H11V12.125H15.125V8H17.875V12.125H22V14.875Z"
              fill="black"
            />
            <defs>
              <filter
                id="filter0_d_3238_12819"
                x="0"
                y="0"
                width="33"
                height="35"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3238_12819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3238_12819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <div class="text-right mr-[70px]">
        <button 
        type="button"
        (click) = "onCostBreakDownSubmit()" 
        class ="save_button"
        >Save</button>
      </div>
    </div>

    <!-- Buttons -->
    <!-- <div class="flex justify-end">
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
      >
        Back
      </button>
      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
      >
        Save
      </button>
    </div> -->
  </form>
</div>
